import { Stage } from '@zooplus/commons-lang';

// FYI : add your custom local domains here
const hostnames = ['localhost', '127.0.0.1'];

const ENV_SHARED = {
  REACT_APP_BFF_EXTERNAL_API_URL: '/explore-bff-api/api',
  CONTENT_BFF_URL: 'https://content-bff-dev.cmsd.ext.aws.zooplus.io',
  isLocalhost: !!window?.location?.hostname && hostnames.includes(window.location.hostname),
};

const ENV_DEVELOPMENT = {
  ...ENV_SHARED,
  CONTENT_BFF_URL: 'https://content-bff-dev.cmsd.ext.aws.zooplus.io',
  stage: 'dev' as Stage,
  isDev: true,
};

const ENV_PRODUCTION = {
  ...ENV_SHARED,
  CONTENT_BFF_URL: 'https://content-bff.cmsp.ext.aws.zooplus.io',
  stage: 'prod' as Stage,
  isDev: false,
};

export const ENV =
  process.env.STAGE === 'dev' ||
  ENV_SHARED.isLocalhost ||
  location.host.indexOf('release') >= 0 ||
  location.host.indexOf('develop') >= 0 ||
  location.host.indexOf('shopk8sd.int.aws.zooplus.io') >= 0 ||
  location.host.indexOf('k8s.www') >= 0
    ? ENV_DEVELOPMENT
    : ENV_PRODUCTION;
